import React from 'react';
import { useNavigate } from 'react-router-dom';
import RecentSignups from './RecentSignups';
import RecentDemos from './RecentDemos';
import { useSupportTicketCount } from './widgets/useSupportTicketCount';
import { ADMIN_PATHS, adminPath } from '../../constants/adminPaths';
import './styles/cards.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const { count: openCount, loading: loadingOpen } = useSupportTicketCount('open');

  return (
    <div className="admin-page">
      <div className="dash-grid">
        <section className="dash-card dash-card--highlight">
          <h2 className="dash-highlight-title">Today&apos;s overview</h2>
          <p className="dash-highlight-subtitle">
            Quick snapshot of your admin activity and workload.
          </p>
          <div className="dash-kpis">
            <div className="dash-kpi">
              <div className="dash-kpi-label">New signups</div>
              <div className="dash-kpi-value">24</div>
            </div>
            <div className="dash-kpi">
              <div className="dash-kpi-label">Upcoming demos</div>
              <div className="dash-kpi-value">7</div>
            </div>
            <div
              className="dash-kpi"
              role="button"
              tabIndex={0}
              onClick={() => navigate(adminPath(ADMIN_PATHS.SUPPORT))}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') navigate(adminPath(ADMIN_PATHS.SUPPORT));
              }}
              style={{ cursor: 'pointer' }}
              title="Open Support Tickets"
            >
              <div className="dash-kpi-label">Open support tickets</div>
              <div className="dash-kpi-value">{loadingOpen ? '—' : (openCount ?? 0)}</div>
            </div>
          </div>
        </section>

        <section className="dash-card">
          <RecentSignups />
        </section>

        <section className="dash-card">
          <RecentDemos />
        </section>
      </div>
    </div>
  );
};

export default Dashboard; 